<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-22 17:38:43
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:54:08
-->
<template>
  <div class="innovative innovative-accuffrivus" :class="{textj: language != 'en'}" ref="accuffrivus">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffrivus.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuffrivus.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-30 p-r-15">
        <img class="wid100" :src="$t('product.accuffrivus.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.accuffrivus.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div class="accuffrivus-advantages">
      <div>
        <div class="innovative-item-title" v-html="$t('product.accuffrivus.list[1].title')"></div>
        <div class="p-t-30 p-b-30">
          <img class="wid100" :src="$t('product.accuffrivus.list[1].m_img')" alt="" srcset="">
        </div>
        <div class="innovative-item-title" v-html="$t('product.accuffrivus.list[2].title')"></div>
        <div class="innovative-accuffrivus-m-h">
          <div class="p-t-20 p-b-40" v-for="item, index in $t('product.accuffrivus.list[2].des')" :key="index">
            <div class="p-b-20 textc">
              <img class="" :src="item.img" alt="" srcset="">
            </div>
            <div class="innovative-wrap-item-title textc fz-30 p-b-25">
              <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
            </div>
            <div v-for="$item, $index in item.list" :key="$index">
              <p class="innovative-characteristics-item ilblk " v-html="$item"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuffrivus.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accuffrivus.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuffrivus {
  .accuffrivus-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding: 50px 30px;
  }
  .innovative-accuffrivus-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 50px 40px 10px 40px;
    img {
      max-width: 60px;
    }
  }
}
</style>
